// extracted by mini-css-extract-plugin
export default {"SplashScreen":"SplashScreen_SplashScreen__fkmmv","loader":"SplashScreen_loader__JhqrE","loader-dot":"SplashScreen_loader-dot__ZN2CK"};